import { query } from "./query";

export const casestudiesQuery = {
  query,
  mocks: {
    defaultData: null,
  },
};
